<!--  -->
<template>
  <div>
    <div class="main">
		<!--nr start-->
		<div class="test_main">
			<div class="nr_left">
				<div class="test">
					<form action="" method="post">
						<div class="test_title">
							<p class="test_time">
								<i class="el-icon-time"></i><b class="alt-1" id="examtime">{{examtime}}</b>
							</p>
							<font><input type="button" name="test_jiaojuan" @click="submitPaper()" value="交卷"></font>
						</div>
						<div v-for="(bigQust,bigindex) in bigQusts" :key="bigindex" >
							<div class="test_content">
								<div class="test_content_title">
									<h2>{{NoToChinese(bigindex+1)}}.{{bigQust.title}}（{{bigQust.remarks}}）</h2>
									<p>
										<span>共</span><i class="content_lit">{{parseInt(bigQust.totalscore)/parseInt(bigQust.fraction) }}</i><span>题，</span><span>合计</span><i class="content_fs">{{bigQust.totalscore}}</i><span>分</span>
									</p>
								</div>
							</div>
							<div class="test_content_nr" v-loading="!bigQust.ishow">
								<ul >
										<li v-for="(qust,index) in bigQust.detailexs" :key="index" :id="`qu_${bigindex}_${index}`">
											<div class="test_content_nr_tt" v-if="bigQust.type!='复合题'">
												<i>{{index+1}}</i><span>({{bigQust.fraction}}分)</span><font >{{qust.title}}</font><b class="el-icon-edit-outline"></b>
												<br/> <img v-if="qust.filepath" :src="`${global.remoteIp}/uploads/${qust.filepath}`" alt="" style="height: 244px">
											</div>
											<div class="test_content_nr_tt" v-else>
												<i>{{index+1}}</i><span>({{bigQust.fraction}}分)</span><p v-html="qust.title"></p><b class="el-icon-edit-outline"></b>
											</div>
											<div class="test_content_nr_main" >
												<ul v-if="bigQust.type=='判断题'">
													<li  v-for="(option,indexex) in jugopts" :key="indexex" :class="`option ${!qust.answer?'':option==getanswer(qust.answer)?'zhengque':'cuowu'}`" >
														
														<label :for="`${bigindex}_answer_${index}_option_${indexex}`" style="font-weight: 100;" :id="`${bigindex}_answer_${index}_optionwz_${indexex}`" >
															<input type="radio" class="radioOrCheck" :name="`answer${bigindex+1}${index+1}`"
															:id="`${bigindex}_answer_${index}_option_${indexex}`"
														/>
															<p class="ue" style="display: inline;">{{option}}</p>
														</label>
													</li>
												</ul>
												<ul v-else-if="qust.foption">
														<li :class="`option ${!qust.answer?'':qust.answer.indexOf(option.slice(0,1))>-1?'zhengque':'cuowu'}`"  v-for="(option,indexex) in qust.foption.replace(/,jh,,jh,/g,',jh,').split(',jh,')" :key="indexex">
															
															<label :for="`${bigindex}_answer_${index}_option_${indexex}`" style="font-weight: 100;" :id="`${bigindex}_answer_${index}_optionwz_${indexex}`">
																<input  :type="bigQust.type=='单选题'?'radio':'checkbox'" class="radioOrCheck" :name="`answer${bigindex+1}${index+1}`"
																	:id="`${bigindex}_answer_${index}_option_${indexex}`"
																/>
																{{option.slice(0,2)}}
																<p class="ue" style="display: inline;">{{option.slice(2)}}</p>
															</label>
														</li>
												</ul>
												
												<el-input
													v-else
													 @input="forceUpdate"
													type="textarea"
													:autosize="{ minRows: 2, maxRows: 4}"
													placeholder="请填写答案"
													:id="`${bigindex}_answer_${index}`"
													@blur="submitQust(bigindex,index)"
													v-model="arrfillanswer[`${bigindex}_answer_${index}`]">
												</el-input>
											</div>
										</li>
								</ul>
							</div>
						</div>
					</form>
				</div>
			</div>
			<div class="nr_right">
				<div class="nr_rt_main">
					<div class="rt_nr1">
						<div class="rt_nr1_title">
							<h1>
								<i class="el-icon-tickets"></i>答题卡
							</h1>
							<p class="test_time">
								<i  class="el-icon-time"></i><b class="alt-1"  id="examtime1"></b>
							</p>
						</div>
							<div class="rt_content" v-for="(bigQust,bigindex) in bigQusts" :key="bigindex">
								<div class="rt_content_tt">
									<h2>{{bigQust.title}}</h2>
									<p>
										<span>共</span><i class="content_lit">{{parseInt(bigQust.totalscore)/parseInt(bigQust.fraction) }}</i><span>题</span>
									</p>
								</div>
								<div class="rt_content_nr answerSheet">
									<ul>
										<li v-for="index of parseInt(parseInt(bigQust.totalscore)/parseInt(bigQust.fraction))" :key="index"><a :href="`#qu_${bigindex}_${index-1}`">{{index}}</a></li>
									</ul>
								</div>
							</div>
					</div>
				</div>
			</div>
		</div>
		<!--nr end-->
		<div class="foot"></div>
	</div>
  </div>
</template>

<script>
import global from "../components/PublicComs/Common.vue";
import { Message } from "element-ui";
export default {
  data () {
    return {
		paper:{
		},
		bigQusts: [],
		global,
		examtime:"",
		loadFinishNum: 0,
		fivetip:false,
		jugopts:["正确","错误"],
		jugoptsw:["توغرا","خاتا"],
		record:{},
		arrfillanswer:{}
    };
  },

  components: {},

  computed: {},

  mounted() {
	if(this.$route.params.id)
    {
      this.$axios.post(`/api/examRecords/startExam/${this.$route.params.id}`).then(res => {
        if(res.data)
        {
           this.paper= res.data.testPaper;
		   if(this.paper.isViwen)this.jugopts = this.jugoptsw;
           this.bigQusts = res.data.testPaper.testPaperInfos;
		   let examtime = this.paper.duration;
		   this.record = res.data.record;
		   let arrQustRecodes = res.data.data;
		   let starttime = this.record.ctime;
		   let ms = (new Date() - new Date(starttime));
		   let starttime1= parseInt(ms/60000) ;
           let time = parseInt(examtime)-starttime1;
		   time = `${parseInt(time/60)}:${time%60}:00`;
		   $("#examtime").text(time)
		   $("#examtime1").text(time)
		   for(let i=0;i<this.bigQusts.length;i++)
			{
				this.bigQusts[i].ishow = false;
				this.$forceUpdate();
					this.$axios.get(`/api/students/testPapers/${this.paper._id}/testPaperInfos/${this.bigQusts[i]._id}`).then(res => {
					if(res.data)
					{
						this.bigQusts[i].detailexs= res.data.questionInfo;
						this.bigQusts[i].ishow = true;
						if(!this.bigQusts[i].detailexs)
						{
							this.bigQusts[i].detailexs =[];
						}
						for(let j=0;j<this.bigQusts[i].detailexs.length;j++){
							let qust = this.bigQusts[i].detailexs[j];
							for(let k=0;k<arrQustRecodes.length;k++)
							{
								if(qust._id==arrQustRecodes[k].questionid)
								{
									this.bigQusts[i].detailexs[j].record = arrQustRecodes[k];
									break;
								}
							}
						}
						this.$forceUpdate();
						this.$nextTick(function(){
							this.loadFinishNum++;
						})
					}
				});
			}
        }
      });
    }
     
	
  },

  methods: {
	  getanswer(answer){
            if(answer=="正确")
            {
                return "正确";
            }else{
                return "错误";
            }
        return answer;
      },
	  submitPaper(){
		this.$axios.post(`/api/examRecords/completeExam/${this.paper._id}`).then(res => {
			// Message.success("提交试卷成功");
			if(res.data.examAchieveMent)
			{
				this.$alert(`<p>试卷得分：${res.data.examAchieveMent.score}分</p>`, '提交试卷成功', {
					dangerouslyUseHTMLString: true
				}).then(() => {
					this.$router.push("/examrecord");
				});
			}else{
				this.$alert('', '提交试卷成功', {
					dangerouslyUseHTMLString: true
				}).then(() => {
					this.$router.push("/examrecord");
				});
			}
          	
		});
	  },
	  submitQust(i,j)
	  {
		var examId = `qu_${i}_${j}`; // 得到题目ID
		var cardLi = $('a[href="#' + examId + '"]'); // 根据题目ID找到对应答题卡
		// 设置已答题
		if(!cardLi.hasClass('hasBeenAnswer')){
			cardLi.addClass('hasBeenAnswer');
		}
		console.log( this.arrfillanswer[`${i}_answer_${j}`])
		this.bigQusts[i].detailexs[j].record.useranswer = this.arrfillanswer[`${i}_answer_${j}`];
		this.$axios.post(`/api/examRecords/editExam/${this.bigQusts[i].detailexs[j].record._id}`,this.bigQusts[i].detailexs[j].record).then(res => {
		});
	  },
	  NoToChinese(num) {
        if (!/^\d*(\.\d*)?$/.test(num)) {
            alert("Number is wrong!");
            return "Number is wrong!";
        }
        var AA = new Array("零", "一", "二", "三", "四", "五", "六", "七", "八", "九");
        var BB = new Array("", "十", "百", "千", "万", "亿", "点", "");
        var a = ("" + num).replace(/(^0*)/g, "").split("."),
            k = 0,
            re = "";
        for (var i = a[0].length - 1; i >= 0; i--) {
            switch (k) {
                case 0:
                    re = BB[7] + re;
                    break;
                case 4:
                    if (!new RegExp("0{4}\\d{" + (a[0].length - i - 1) + "}$").test(a[0]))
                        re = BB[4] + re;
                    break;
                case 8:
                    re = BB[5] + re;
                    BB[7] = BB[5];
                    k = 0;
                    break;
            }
            if (k % 4 == 2 && a[0].charAt(i + 2) != 0 && a[0].charAt(i + 1) == 0) re = AA[0] + re;
            if (a[0].charAt(i) != 0) re = AA[a[0].charAt(i)] + BB[k % 4] + re;
            k++;
        }
        if (a.length > 1) //加上小数部分(如果有小数部分) 
        {
            re += BB[6];
            for (var i = 0; i < a[1].length; i++) re += AA[a[1].charAt(i)];
        }
        return re;
    },
	forceUpdate() {
		this.$forceUpdate()
	},
  },
  watch:{
	loadFinishNum(newVal){
		console.log(newVal)
		if(newVal==this.bigQusts.length)
		{
			window.jQuery(($)=> {
				"use strict";
				$('time').countDown({
					with_separators : false
				});
				$('.alt-1').countDown({
					css_class : 'countdown-alt-1'
				},) .on('time.elapsing', ()=>{  
					if(!this.fivetip)
					this.$confirm('距离考试结束还有5分钟，请考生抓紧时间作答，时间到后会自动交卷！', '提示', {
						confirmButtonText: '确定',
						type: 'warning',
						center: true
					})
					this.fivetip = true;
				}).on('time.elapsed', ()=>{
					//自动交卷
					this.submitPaper();
				});  
				$('.alt-2').countDown({
					css_class : 'countdown-alt-2'
				});
			});
			let alphabet=['A', 'B', 'C', 'D', 'E', 'F','G','H','J','K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R','S','T'];
			for(let i = 0; i <this.bigQusts.length; i++){
				
				for(let j = 0; j < this.bigQusts[i].detailexs.length; j++)
				{
					if( this.bigQusts[i].detailexs[j].record&& this.bigQusts[i].detailexs[j].record.useranswer)
					{
						let answer = this.bigQusts[i].detailexs[j].record.useranswer;
						if(this.bigQusts[i].type=="单选题")
						{
							let index = alphabet.indexOf(answer);
							$(`#${i}_answer_${j}_option_${index}`).attr("checked","true");
						}else if(this.bigQusts[i].type=="多选题")
						{
							let arransw = answer.split(",");
							for(let h= 0; h < arransw.length; h++)
							{
								let index = alphabet.indexOf(arransw[h]);
								$(`#${i}_answer_${j}_option_${index}`).attr("checked",true);
							}
						}else if(this.bigQusts[i].type=="判断题")
						{
							let index = this.jugopts.indexOf(answer);
							$(`#${i}_answer_${j}_option_${index}`).attr("checked",true);
						}else
						{
							//this.arrfillanswer[i][j] = answer;
							 this.arrfillanswer[`${i}_answer_${j}`]=answer;
							 this.$forceUpdate();
						}
						
						var examId = `qu_${i}_${j}`; // 得到题目ID
						var cardLi = $('a[href="#' + examId + '"]'); // 根据题目ID找到对应答题卡
						// 设置已答题
						if(!cardLi.hasClass('hasBeenAnswer')){
							cardLi.addClass('hasBeenAnswer');
						}
					}
				}
			}
			let _this = this;
			$(function() {
				$('li.option label').click(function() {
					var examId = $(this).closest('.test_content_nr_main').closest('li').attr('id'); // 得到题目ID
					var cardLi = $('a[href="#' + examId + '"]'); // 根据题目ID找到对应答题卡
					// 设置已答题
					if(!cardLi.hasClass('hasBeenAnswer')){
						cardLi.addClass('hasBeenAnswer');
					}
					var arrstr = examId.split('_');
					var bigQustIndex = parseInt(arrstr[1]);
					var qustIndex = parseInt(arrstr[2]);
					if(_this.bigQusts[bigQustIndex].type == "单选题")
					{
						var answerId = this.id;
						var intanwer = answerId.slice(answerId.lastIndexOf("_")+1);
						
						_this.bigQusts[bigQustIndex].detailexs[qustIndex].record.useranswer=alphabet[parseInt(intanwer)];
					}
					else if(_this.bigQusts[bigQustIndex].type == "多选题"){
						var stranswer = "";
						var answerId = this.id;
						for (var i =0;i<_this.bigQusts[bigQustIndex].detailexs[qustIndex].foption.replace(/,jh,,jh,/g,',jh,').split(',jh,').length;i++)
						{
							console.log($(`#${bigQustIndex}_answer_${qustIndex}_option_${i}`));
							console.log($(`#${bigQustIndex}_answer_${qustIndex}_option_${i}`)[0].checked)
							if($(`#${bigQustIndex}_answer_${qustIndex}_option_${i}`)[0].checked== true)
							{
								stranswer+=alphabet[i]+",";
							}
							// if(`${bigQustIndex}_answer_${qustIndex}_optionwz_${i}`==answerId&&$(`#${bigQustIndex}_answer_${qustIndex}_option_${i}`)[0].checked== false)
							// {
							// 	stranswer+=alphabet[i]+",";
							// }
							// &&`${bigQustIndex}_answer_${qustIndex}_optionwz_${i}`!==answerId
						}
						if(stranswer.slice(-1)==",")stranswer=stranswer.slice(0,stranswer.length-1);
						_this.bigQusts[bigQustIndex].detailexs[qustIndex].record.useranswer=stranswer;
						
					}
					else if(_this.bigQusts[bigQustIndex].type == "判断题"){
						var answerId = this.id;
						var intanwer = answerId.slice(answerId.lastIndexOf("_")+1);
						_this.bigQusts[bigQustIndex].detailexs[qustIndex].record.useranswer=_this.jugopts[parseInt(intanwer)];
					}
					_this.$axios.post(`/api/examRecords/editExam/${_this.bigQusts[bigQustIndex].detailexs[qustIndex].record._id}`,_this.bigQusts[bigQustIndex].detailexs[qustIndex].record).then(res => {
					});
				});
			});
		}
	}
  }
}

</script>
<style lang="scss" scoped>
.hasBeenAnswer {
	background: #5d9cec;
	color:#fff;
}
.cuowu:hover{

color: red;

}
.zhengque:hover{
color: rgb(16, 211, 42);	
}
@import "@/assets/css/iconfont.scss";
@import "@/assets/css/test.scss";
@import "@/assets/css/main.scss";
</style>